import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { DELETE_PARAM } from "./actionTypes";
import { deleteParametersSuccess, deleteParametersError } from "./actions";

// Include call API
import { getParametersAPI } from "../../../api/securityparameters";

const parametersAPI = getParametersAPI();

function* deleteParameter({ payload: {user, param,  history} }) {
  try {
    const response = yield call(parametersAPI.deleteParameter, param, user.token);
    yield put(deleteParametersSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(deleteParametersError(error));
  }
}

export function* watchDeleteParameters() {
  yield takeEvery(DELETE_PARAM, deleteParameter);
}

function* deleteParametersSaga() {
  yield all([fork(watchDeleteParameters)]);
}

export default deleteParametersSaga;
